"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNestedObject = exports.fromError = exports.merge = exports.only = exports.has = exports.get = exports.except = void 0;
const deepmerge_1 = __importDefault(require("deepmerge"));
const except = (input, excludeKeys) => {
    excludeKeys = Array.isArray(excludeKeys) ? excludeKeys : [excludeKeys];
    return {
        ...Object.keys(input)
            .filter(key => !excludeKeys.includes(key))
            .reduce((acc, key) => ({
            ...acc,
            [key]: input[key],
        }), {}),
    };
};
exports.except = except;
/**
 * Get a value out of an object using dot notation.
 */
const get = (input, dotNotationAddress) => {
    dotNotationAddress = sanitizeDotNotation(dotNotationAddress);
    const path = dotNotationAddress.split('.');
    return path.reduce((acc, key) => acc?.[key], input);
};
exports.get = get;
const has = (input, dotNotationAddress) => {
    dotNotationAddress = sanitizeDotNotation(dotNotationAddress);
    const path = dotNotationAddress.split('.');
    let childPath;
    let parentObject;
    if (path.length === 1) {
        parentObject = input;
        childPath = path[0]; // eslint-disable-line prefer-destructuring
    }
    else {
        const parentPath = path.slice(0, -1).join('.');
        parentObject = (0, exports.get)(input, parentPath) || {};
        childPath = path[path.length - 1];
    }
    return Object.keys(parentObject).some(key => key === childPath);
};
exports.has = has;
const sanitizeDotNotation = (input) => input.replace(/\[([0-9]*)\]/g, '.$1');
const only = (input, includeKeys) => {
    includeKeys = Array.isArray(includeKeys) ? includeKeys : [includeKeys];
    return {
        ...Object.keys(input)
            .filter(key => includeKeys.includes(key))
            .reduce((acc, key) => ({
            ...acc,
            [key]: input[key],
        }), {}),
    };
};
exports.only = only;
const merge = (objA, objB) => (0, deepmerge_1.default)(objA, objB);
exports.merge = merge;
const fromError = (error) => Object.getOwnPropertyNames(error)
    .reduce((acc, key) => {
    acc[key] = error[key];
    return acc;
}, {});
exports.fromError = fromError;
const createNestedObject = (data) => {
    const result = {};
    Object.keys(data).forEach(key => {
        const parts = key.split('.');
        const last = parts.pop();
        let node = result;
        parts.forEach((part) => {
            if (!(part in node)) {
                node[part] = {};
            }
            node = node[part];
        });
        node[last] = data[key];
    });
    return result;
};
exports.createNestedObject = createNestedObject;
